export const greenLeafDataLocator = {
    green_leaf_label_testId: 'green_leaf_label_testId',
    green_leaf_info_modal_testId: 'green_leaf_info_modal_testId'
};